var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-wrap align-items-start justify-content-between gap-2 mb-2",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "btn btn-outline-secondary btn-sm",
            attrs: { to: "/riwayat-pasien" },
          },
          [
            _c("i", { staticClass: "fa fa-arrow-left" }),
            _vm._v(" Kembali ke Daftar Pasien\n        "),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "card border-0 shadow-sm mb-3 bg-light-subtle" }, [
      _c("div", { staticClass: "card-body py-3" }, [
        _c("div", { staticClass: "row g-3 align-items-center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "fw-bold fs-5" }, [
              _vm._v(_vm._s(_vm.pasien.nama || "—")),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-muted small d-flex flex-wrap gap-3" },
              [
                _c("span", [
                  _c("i", { staticClass: "fa fa-id-card me-1" }),
                  _vm._v("No. RM " + _vm._s(_vm.medrec)),
                ]),
                _vm._v(" "),
                _vm.pasien.sex
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-venus-mars me-1" }),
                      _vm._v(_vm._s(_vm.pasien.sex)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.pasien.bod
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-birthday-cake me-1" }),
                      _vm._v(
                        _vm._s(_vm.formatTanggal(_vm.pasien.bod)) +
                          "\n                        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fa fa-history me-1" }),
                  _vm._v(_vm._s(_vm.history_data.length) + " registrasi"),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card border-0 shadow-sm mb-3" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row g-3" }, [
          _c("div", { staticClass: "col-12 col-lg-6" }, [
            _c(
              "label",
              { staticClass: "form-label small fw-semibold text-muted" },
              [_vm._v("Unit Tindakan")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-group w-100", attrs: { role: "group" } },
              [
                _vm._l(_vm.unit_tindakan_options, function (unit) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filter.unit_tindakan,
                          expression: "filter.unit_tindakan",
                        },
                      ],
                      key: `unit-input-${unit.value}`,
                      staticClass: "btn-check",
                      attrs: {
                        type: "radio",
                        name: "unit_tindakan",
                        id: `unit-${unit.value}`,
                      },
                      domProps: {
                        value: unit.value,
                        checked: _vm._q(_vm.filter.unit_tindakan, unit.value),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(
                            _vm.filter,
                            "unit_tindakan",
                            unit.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        key: `unit-label-${unit.value}`,
                        staticClass: "btn btn-outline-success",
                        attrs: { for: `unit-${unit.value}` },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(unit.label) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-lg-6" }, [
            _c(
              "label",
              {
                staticClass: "form-label small fw-semibold text-muted",
                attrs: { for: "cari_pasien" },
              },
              [
                _vm._v(
                  "\n                        Cari Pasien\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.cari_pasien,
                    expression: "filter.cari_pasien",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "cari_pasien",
                  type: "text",
                  placeholder: "No. Registrasi",
                },
                domProps: { value: _vm.filter.cari_pasien },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getHistoryPasien.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.filter, "cari_pasien", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-4" },
            [
              _c(
                "label",
                { staticClass: "form-label small fw-semibold text-muted" },
                [_vm._v("Dokter yang Merawat")]
              ),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  options: _vm.options.dokter,
                  filterable: false,
                  label: "label",
                  placeholder: "Semua dokter",
                },
                on: {
                  search: _vm.searchDokter,
                  open: function ($event) {
                    return _vm.searchDokter("")
                  },
                  input: function ($event) {
                    _vm.filter.dokter_rawat = $event ? $event.value : ""
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "no-options",
                    fn: function () {
                      return [_vm._v("Ketik untuk mencari dokter...")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selected.dokter,
                  callback: function ($$v) {
                    _vm.$set(_vm.selected, "dokter", $$v)
                  },
                  expression: "selected.dokter",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-4" },
            [
              _c(
                "label",
                { staticClass: "form-label small fw-semibold text-muted" },
                [_vm._v("History Layanan Poli")]
              ),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  options: _vm.options.poli,
                  filterable: false,
                  label: "label",
                  placeholder: "Semua poli",
                },
                on: {
                  search: _vm.searchPoli,
                  open: function ($event) {
                    return _vm.searchPoli("")
                  },
                  input: function ($event) {
                    _vm.filter.history_poli = $event ? $event.value : ""
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "no-options",
                    fn: function () {
                      return [_vm._v("Ketik untuk mencari poli...")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selected.poli,
                  callback: function ($$v) {
                    _vm.$set(_vm.selected, "poli", $$v)
                  },
                  expression: "selected.poli",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-4" },
            [
              _c(
                "label",
                { staticClass: "form-label small fw-semibold text-muted" },
                [_vm._v("History Diagnosa")]
              ),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  options: _vm.options.diagnosa,
                  filterable: false,
                  label: "label",
                  placeholder: "Semua diagnosa",
                },
                on: {
                  search: _vm.searchDiagnosa,
                  open: function ($event) {
                    return _vm.searchDiagnosa("")
                  },
                  input: function ($event) {
                    _vm.filter.history_diagnosa = $event ? $event.value : ""
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "no-options",
                    fn: function () {
                      return [_vm._v("Ketik untuk mencari diagnosa...")]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.selected.diagnosa,
                  callback: function ($$v) {
                    _vm.$set(_vm.selected, "diagnosa", $$v)
                  },
                  expression: "selected.diagnosa",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex justify-content-end gap-2 mt-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-danger",
              attrs: { disabled: _vm.is_loading },
              on: { click: _vm.resetFilter },
            },
            [
              _c("i", { staticClass: "fa fa-refresh" }),
              _vm._v(" Reset\n                "),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: _vm.is_loading },
              on: { click: _vm.getHistoryPasien },
            },
            [
              _c("i", {
                staticClass: "fa",
                class: _vm.is_loading ? "fa-spinner fa-spin" : "fa-search",
              }),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.is_loading ? "Memuat..." : "Cari") +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card border-0 shadow-sm" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "card-body position-relative" }, [
        _vm.is_loading
          ? _c("div", { staticClass: "table-loading" }, [
              _c("div", {
                staticClass: "spinner-border text-success",
                attrs: { role: "status" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2 fw-semibold text-muted" }, [
                _vm._v("Memuat data..."),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "table table-hover align-middle mb-0" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.history_data, function (row, index) {
                  return _c("tr", { key: row.Regno }, [
                    _c("td", [_vm._v(_vm._s(index + 1))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.openRiwayat(row.Regno)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa fa-folder-open" }),
                          _vm._v(
                            " Riwayat Pelayanan\n                                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "fw-semibold" }, [
                      _vm._v(_vm._s(row.Regno)),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.Medrec))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.formatTanggal(row.Regdate)))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.Firstname))]),
                    _vm._v(" "),
                    _c("td", [
                      row.icd10
                        ? _c("span", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(row.icd10.KDICD) +
                                " - " +
                                _vm._s(row.icd10.DIAGNOSA) +
                                "\n                                "
                            ),
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("-"),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(row.poli ? row.poli.NMPoli : "-")),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            row.fppri && row.fppri.bangsal
                              ? row.fppri.bangsal.NmBangsal
                              : "-"
                          ) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "span",
                        {
                          staticClass: "badge",
                          class: row.fppri
                            ? "bg-warning text-dark"
                            : "bg-info text-dark",
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(row.fppri ? "Rawat Inap" : "Rawat Jalan") +
                              "\n                                "
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                !_vm.is_loading && !_vm.history_data.length
                  ? _c("tr", [_vm._m(6)])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "modal-riwayat-pelayanan",
          tabindex: "-1",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-xl modal-dialog-scrollable modal-fullscreen-lg-down",
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header bg-success text-white" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _c("i", { staticClass: "fa fa-folder-open me-1" }),
                  _vm._v(" Riwayat Pelayanan\n                        "),
                  _vm.active_regno
                    ? _c("small", { staticClass: "opacity-75" }, [
                        _vm._v("— No. Reg " + _vm._s(_vm.active_regno)),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn-close btn-close-white",
                  attrs: { type: "button", "data-bs-dismiss": "modal" },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body bg-body-tertiary" },
                [
                  _vm.active_regno
                    ? _c("RiwayatPelayananDetail", {
                        attrs: { regno: _vm.active_regno },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(7),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "mb-0" }, [_vm._v("Riwayat Pelayanan")]),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v(
          "\n                Seluruh registrasi milik satu pasien beserta riwayat pemeriksaannya.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("div", { staticClass: "avatar-circle" }, [
        _c("i", { staticClass: "fa fa-user" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "card-header bg-white fw-semibold d-flex align-items-center gap-2",
      },
      [
        _c("i", { staticClass: "fa fa-filter text-success" }),
        _vm._v(" Pencarian Data\n        "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-search" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-white fw-semibold" }, [
      _c("i", { staticClass: "fa fa-list-ul text-success me-1" }),
      _vm._v(" Riwayat Registrasi\n        "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "50px" } }, [_vm._v("No")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "180px" } }, [_vm._v("Aksi")]),
        _vm._v(" "),
        _c("th", [_vm._v("No. Registrasi")]),
        _vm._v(" "),
        _c("th", [_vm._v("No. RM")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tgl Daftar")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Diagnosa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Poli")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ruangan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Unit")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "text-center text-muted py-4", attrs: { colspan: "10" } },
      [
        _c("i", { staticClass: "fa fa-inbox fa-2x d-block mb-2" }),
        _vm._v(
          "\n                                Tidak ada riwayat registrasi yang cocok dengan filter.\n                            "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n                        Tutup\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }